import React, { useLayoutEffect, useRef } from "react";

const SIZES = [18.4, 17, 16, 15, 14, 13, 12, 11, 10];

export function FitText({ text }) {
  const ref = useRef(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const fit = () => {
      for (const size of SIZES) {
        el.style.fontSize = `${size}px`;
        el.style.lineHeight = size >= 13 ? "24px" : `${Math.floor(size * 1.05)}px`;
        if (el.scrollHeight <= el.clientHeight) return;
      }
    };
    fit();
    const ro = new ResizeObserver(fit);
    ro.observe(el);
    if (document.fonts?.ready) document.fonts.ready.then(fit);
    return () => ro.disconnect();
  }, [text]);

  return (
    <span ref={ref} className="sp-fit-text" data-testid="army-select-value">
      {text}
    </span>
  );
}
